export const REPORT_MASTER_REQUEST = 'REPORT_MASTER_REQUEST';
export const REPORT_MASTER_REQUEST_SUCCESS = 'REPORT_MASTER_REQUEST_SUCCESS';
export const REPORT_MASTER_REQUEST_FAILURE = 'REPORT_MASTER_REQUEST_FAILURE';
export const GET_REPORT_MASTER = 'GET_REPORT_MASTER';
export const CREATE_REPORT_MASTER = 'CREATE_REPORT_MASTER';
export const UPDATE_REPORT_MASTER = 'UPDATE_REPORT_MASTER';
export const DELETE_REPORT_MASTER = 'DELETE_REPORT_MASTER';